export const MarketShopColors = {
  marketShopBrand100: '#1d4fff1a' as const,
  marketShopBrand300: '#1d4fff66' as const,
  marketShopBrand400: '#1d4fff99' as const,
  marketShopBrand800: '#1d4fff' as const,
  marketShopChipGreen: '#77C820' as const,
  marketShopChipRed: '#FF4800' as const,
}

export type MarketShopColorsType = typeof MarketShopColors
